import RightContent from "../../components/OnBoard/RightContent";
import cogoToast from "cogo-toast-react-17-fix";
import Menu from "../../components/OnBoard/Menu";
import styles from "./UserOnboarding1.module.css";
import {useNavigate } from "react-router-dom";
import { BASE_URL, UPDATE_PHONE } from "../../Utils/constant";
import Error from "../../components/OnBoard/Error";
import { useState } from "react";
import API from "../../ApiConfig";
const ChangePhone = () => {
  const userData = JSON.parse(localStorage.getItem("user_data"))
  const [phoneNumber, setPhoneNumber] = useState(userData.phone_number)

  if(userData==null){
    return(<Error Message={"Some Error Occured"}/>)
  }

  const navigate=useNavigate();

  const changeNumber=()=>{
    if(phoneNumber==userData.phone_number){
      navigate('/app/registration/step1')
    }
    else{
      API.put(UPDATE_PHONE+userData.email+"?phone_number="+phoneNumber)
      .then(data =>{
        let res=data.data
        if(res.success==true){
          cogoToast.success("Updated phone")
          userData.phone_number = phoneNumber
          window.localStorage.setItem("user_data", JSON.stringify(userData))
          navigate('/app/registration/step1')

        }
        else{
          cogoToast.error("Error in Changing phone\n"+data.respose.data.message)
        }
      }).catch((err)=>cogoToast.error(err.response.data.message));
    }
  }

  return (
    <div className={styles.userOnboarding}>
      <RightContent/>
      <section className={styles.leftContent}>
        <div className={styles.progressForm}>
          <div className={styles.progressForm1}>
            <Menu pos="2" USER={userData.IsVerifier}/>
            <div className={styles.form}>
              <div className={styles.headingHelperText}>
              <h3 className={styles.heading}>Enter New Number</h3>
                <div className={styles.userInputBox}>
                  <label className={styles.phoneLabel}>Enter number</label>
                  <input type="tel" id="phone" value={phoneNumber} name="phone" placeholder="+91 9988999898989" onChange={(e)=>{setPhoneNumber(e.target.value)}} maxLength={10} />
                </div>
              </div>
            </div>
          </div>
          <button className="Btn primaryBtn" style={{width:"50%"}} onClick={changeNumber}>Next: Verify Phone Number</button>

        </div>
      </section>
    </div>
  );
};

export default ChangePhone;
